export const copyToClipboard = (value: string): void => {
  const $input = document.createElement('input');

  $input.type = 'text';
  $input.className = 'clipboard-input';

  document.body.appendChild($input);

  $input.value = value;
  $input.select();

  document.execCommand('copy');

  $input.remove();
};

export const addLinkGoogleFonts = (): void => {
  // plan B - Google Fonts
  const linkGoogleFontsDMSans = document.createElement('link');

  linkGoogleFontsDMSans.rel = 'stylesheet';
  linkGoogleFontsDMSans.type = 'text/css';
  linkGoogleFontsDMSans.crossOrigin = 'anonymous';
  linkGoogleFontsDMSans.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap';

  document.head.appendChild(linkGoogleFontsDMSans);
};

export const addScriptMercadoPago = (): void => {
  const script = document.createElement('script');
  script.src = 'https://sdk.mercadopago.com/js/v2';
  script.async = true;
  script.onload = () => scriptLoaded();

  document.body.appendChild(script);
};

export const scriptLoaded = (): void => {
  window.mp = new window.MercadoPago(process.env.VUE_APP_MERCADO_PAGO_KEY);
};

export const addScriptKoin = (): void => {
  const script = document.createElement('script');
  script.src = 'https://resources.koin.com.br/scripts/koin.min.js';
  script.setAttribute('id', 'script-koin');
  script.async = true;
  script.onload = () => getKoinFraudIDByScript();

  document.body.appendChild(script);
};

export const getKoinFraudIDByScript = (): void => {
  window.GetKoinFraudID(function (guid: any) {
    window.koin = guid;
  });
};

export const removeScriptKoin = (): void => {
  const elem: any = document.getElementById('script-koin');

  elem && elem.parentNode.removeChild(elem);
};
